import React from 'react'
import { artist } from '../type'
import data from "../utils//artists.json"
import Artist from '../components/Artist'
import Title from '../components/Title'

function Gallery() {
    const artists: artist[] = data.artists
    return (
        <section>
            <Title title='ステージイベント出演団体'/>
            <div className='grid grid-cols-2'>
                {artists.map((artist) => {
                    return <Artist className='my-2 mx-10' name={artist.name} imgPath={artist.imgPath} comment={artist.comment} link={artist.link} />
                })}
            </div>
        </section>
    )
}

export default Gallery